import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { ListModal } from 'src/app/features/multi-auction-bidder/core/modal/list-modal';
import { Subscription } from 'rxjs';
import { SocketService } from 'src/app/features/bidders/core/service/socket.service';
import { SocketEventType } from 'src/app/features/bidders/core/modal/socket-event-type';
import { BidderList } from 'src/app/features/multi-auction-bidder/core/modal/bidders-list';
import { ConfigService } from 'src/app/core/service/config.service';
import { RoomDetailesModal } from 'src/app/features/multi-auction-bidder/core/modal/roomDetailes-modal';
import { SideNavConfigService, SideNavModal } from 'src/app/layout/main-layout/side-nav-config.service';
import { ApiAuctionsService } from 'src/app/features/bidders/core/service/api-auctions.service';
import { AuctionModal } from 'src/app/features/bidders/core/modal/auctions';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Gallery, ImageItem, ImageSize, ThumbnailsPosition, VideoItem } from 'ng-gallery';
import { Lightbox } from 'ng-gallery/lightbox';
import { ChangeStatusComponent } from '../../../auction/admin-auction-config/change-status/change-status.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmComponent } from 'src/app/shared/actions/delete/confirm.component';
import { AuctionsService } from 'src/app/features/rooms/core/service/auctions.service';
import { CreateAuctionComponent } from 'src/app/features/rooms/component/createAuction/createAuction.component';
import { ItemInfoComponent } from '../../../auction/item-info/item-info.component';
import { ShowItemDetailesComponent } from '../show-item-detailes/show-item-detailes.component';

@Component({
  selector: 'app-item-detailes-multi',
  templateUrl: './item-detailes-multi.component.html',
  styleUrls: []
})
export class ItemDetailesMultiComponent implements OnInit {
  @Input() itemDetails!: any;
  @Input() newBidding!: any;
  @Input() roomdetails: RoomDetailesModal | any;
  @Input() activeAuctionWork: any;
  @Output() CurrentItemIsPublished = new EventEmitter<0 | 1>();
  @Output() getBidders = new EventEmitter;
  @Output() itemDeleted = new EventEmitter<string>();
  // @Input() itemId!: string;


  bidders: BidderList | any;
  userInfo: any;
  subscriptions: Subscription[] = []
  loading: boolean = false;
  // itemDetails!: AuctionModal;
  customOptions: OwlOptions = {
    rtl: localStorage.getItem("language") == "ar" ? true : false,
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    center: true,
    navSpeed: 700,
    margin: 25,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 4
      },
      740: {
        items: 4
      },
      940: {
        items: 4
      },
      1200: {
        items: 6
      }
    },
    nav: false
  }

  slider: any;
  MediaList: any;
  constructor(public socket: SocketService,
    public _config: ConfigService,
    private _sideNavService: SideNavConfigService,
    private _auctionService: ApiAuctionsService,
    private _auction: AuctionsService,
    public gallery: Gallery,
    public lightbox: Lightbox,
    private dialog: MatDialog
  ) {
    this.userInfo = _config.getAuthUserInfo();
  }
  ngOnInit() {
    // this.OnShowItemDetails()
    this.onGetBidders();


    // this.subscriptions.push(
    //   this.socket.getDataStream<string>(`${this.roomdetails.id}`)
    //     .subscribe(message => {

    //       if (this.bidders.length == 2) {
    //         this.bidders.pop();
    //       }
    //       ;
    //       this.bidders = [...[message.data.response.item], ...this.bidders];
    //       this.getBidders.emit(this.bidders);
    //     })
    // )

    if (this.itemDetails && this.userInfo?.user?.role_code == "Admin") {
      // debugger
      this.GetItemDetails(this.itemDetails.id)
    }
  }
  onGetBidders() {
    this.socket?.socket?.emit("getBidders", { id: this.itemDetails?.id, type: 'multi' });

    this.subscriptions.push(
      this.socket.getDataStream<string>(SocketEventType.Get_Bidders)
        .subscribe(message => {
          this.bidders = message.data;
          this.getBidders.emit(this.bidders);
          if (this.itemDetails?.is_closed) {
            if (this.bidders.length) {
              this.itemDetails.winner = this.bidders[0]
            } else {
              this.itemDetails.winner = null;
            }
          }

        })
    )

  }
  ngOnChanges(changes: any): void {
    this.onGetBidders();

    if ('roomdetails' in changes) {
      this.subscriptions.push(
        this.socket.getDataStream<string>(`${changes.currentValue?.id}`)
          .subscribe(message => {

            if (this.bidders.length == 5) {
              this.bidders.pop();
            };

            this.bidders = [...[message.data.response.item], ...this.bidders];
            this.getBidders.emit(this.bidders);
          })
      )
      if (this.roomdetails.type == 'completed') {
        if (this.bidders.length) {
          this.itemDetails.winner = this.bidders[0]
        } else {
          this.itemDetails.winner = null;
        }
      }

    }
    if ('itemDetails' in changes) {
      // if (changes.itemDetails.currentValue?.id && this.userInfo?.user?.role_code == "Admin") {

      //   this.GetItemDetails(changes.itemDetails.currentValue.id)
      // }
      // debugger
      if (!changes?.itemDetails?.currentValue?.id) {
        this.itemDetails = null;
      }

    }

  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());

  }
  // OnShowItemDetails() {
  //   // this.menu.ToggleWallet(true)
  //   let configSidenav: SideNavModal = {
  //     status: true,
  //     type: 'item_details',
  //     id: this.itemDetails?.id,
  //     disableClose: false
  //   }
  //   this._sideNavService.ChangeSideNav(configSidenav)
  // }

  GetItemDetails(ItemId: string) {
    this.loading = true;
    // debugger
    this._auctionService.getOneAuction(ItemId).subscribe({
      next: (result) => {
        this.loading = false;
        // debugger
        result.data.showActions = this.itemDetails.showActions;
        this.itemDetails = result.data;
        this.slider = result.data.files.filter((file: any) => file.isMain == 0);
        this.MediaConfig()
      },
      error: (error) => {
        this.loading = false;
        this._config.showErrors(error);
      }
    })
  }

  MediaConfig() {

    /** Basic Gallery Example */

    // Creat gallery items
    this.MediaList = this.slider.map((item: any) => {
      console.log(item);
      if (item.type === 'video') {
        return new VideoItem({ src: item.path, thumb: "assets/images/defualt_thumbnail.png", controls: true, autoplay: false, preload: 'auto' });
      } else {
        return new ImageItem({ src: item.path, thumb: item.path });
      }
    });


    /** Lightbox Example */

    // Get a lightbox gallery ref
    const galleryId = 'lightbox';
    const galleryRef = this.gallery.ref(galleryId);
    // Add custom gallery config to the lightbox (optional)
    galleryRef.setConfig({
      imageSize: 'cover',       // Keeps portrait images and videos properly scaled
      autoPlay: false,            // Prevents auto-advancing slides during video playback
      loop: true,                 // Infinite scrolling looping
      counter: true,              // Displays the slide index number (e.g., 1 / 5)

      // 📸 ENABLE THUMBNAILS AT THE BOTTOM
      thumb: true,                // 👈 Re-enables the thumbnail row
      thumbPosition: 'bottom',    // 👈 Forces the thumbnail panel below the media view
      thumbWidth: 100,            // (Optional) Sets the width of each thumbnail in pixels
      thumbHeight: 75,            // (Optional) Sets the height of each thumbnail in pixels

      // Smooth navigation transitions config
      slidingEase: {
        x1: 0.25,
        y1: 0.46,
        x2: 0.45,
        y2: 0.94
      },
      slidingDuration: 350
    });

    // Load items into the lightbox gallery ref
    galleryRef.load(this.MediaList);
  }

  publishAuction(status: number) {
    const dataConfirmActions = {
      title: this._config.translate.instant("actions.confirmTitle"),
      icon: 'warning',
      text: this._config.translate.instant("actions.confirmTxt"),
      confirm: this._config.translate.instant("actions.confirm"),
      cancel: this._config.translate.instant("actions.cancel"),
      data: { auctionId: this.itemDetails.id, room_id: this.itemDetails, is_published: status },
    };
    const dialogRef = this.dialog.open(ChangeStatusComponent, {
      data: dataConfirmActions,
      panelClass: 'customDialogStyle'
    });
    dialogRef.afterClosed().subscribe((res) => {


      if (res == 'success') {
        // this.reloadPage.emit(true);
        if (status) {
          this.itemDetails.is_published = 0;
          this.CurrentItemIsPublished.emit(0);

        } else {
          this.itemDetails.is_published = 1;
          this.CurrentItemIsPublished.emit(1);

        }
      }

    });
  }


  DeleteAuction() {
    const dataConfirmActions = {
      title: this._config.translate.instant("actions.confirmTitle"),
      icon: 'warning',
      text: this._config.translate.instant("actions.confirmTxt"),
      confirm: this._config.translate.instant("actions.confirm"),
      cancel: this._config.translate.instant("actions.cancel"),
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      data: dataConfirmActions,
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'success') {
        this._auction.DeleteAuction(this.itemDetails.id).subscribe({
          next: (data) => {
            this._config.toastrService.success(data.message)
            // this._config.goTo("/rooms/detailes/" + this.itemDetails.room_id)
            this.itemDeleted.emit(this.itemDetails?.id);
          },
          error: (err) => {
            this._config.showErrors(err)
          }
        })

      }
    })
  }

  onEditAuction() {
    const dialogRef = this.dialog.open(CreateAuctionComponent, {
      width: 'auto',
      minWidth: "400px",
      data: {
        auctionId: this.itemDetails.id,
        room_id: this.itemDetails.room_id,
        btnSubmit: this._config.translate.instant("Auctions.save"),
        Title: this._config.translate.instant("Auctions.Update Item")
      },
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      if (res === true) {
        this.GetItemDetails(this.itemDetails?.id)
      }
    })
  }


  OnShowItemDetails() {
    // const dialogRef = this.dialog.open(ShowItemDetailesComponent, {
    //   width: '800px',
    //   height: "auto",
    //   data: {
    //     itemId: this.itemDetails.id,
    //   },
    //   panelClass: 'customDialogStyle'
    // });

    // dialogRef.afterClosed().subscribe((res: any) => {
    //   if (res === true) {
    //     // this.reloadPage.emit()
    //   }
    // })
    let data: SideNavModal = {
      disableClose: false,
      id: this.itemDetails.id,
      status: true,
      type: 'item_details'
    }
    this._sideNavService.ChangeSideNav(data);
  }




}
